import type {ReactNode} from 'react';
import React from 'react'
import ContentSection from './ContentSection';

type Props = {
    title: string;
    children: ReactNode
    number?: number;
    grid?: boolean;
    storageKey?: string
};

const Step: React.FC<Props> = ({children, title, number, storageKey, grid}) => {
    if (grid) {
        children = <div className="grid">{children}</div>;
    }

    return (
        <ContentSection title={(number ? `${number}. ` : '') + title} storageKey={storageKey} noScroll>
            {children}
        </ContentSection>
    );
}

export default Step
